import React from 'react'
import PropTypes from 'prop-types'
import { FaTimes, FaArrowRight, FaBars } from 'react-icons/fa'
import PortraitListItem from './PortraitListItem'
import { ReactComponent as Logo } from '../../../media/yoco-logo-ghost.svg'

import {
  Drawer,
  Header,
  Main,
  Footer,
  BtnGetStarted,
  IconClose,
  IconLogo,
  PortraitList,
  PortraitLink,
  PortraitContainer,
  BtnBurger,
  Menu,
  BtnMenuLogin,
  MenuLogo,
} from './styled'
import { TypeLink } from '../../../utils/types'

export const NavigationPortrait = ({
  links = [],
  isNavOpen,
  onDropDownAction,
  onMenuAction,
  isLoginButtonVisible = true,
  getStartedUrl = 'https://signup.yoco.co.za/',
}) => {
  // const [isScrollingUp] = useVerticalScroll()
  const isScrollingUp = false

  return (
    <PortraitContainer isScrollingUp={isScrollingUp}>
      <Menu isOpen={isNavOpen}>
        <BtnBurger onClick={onMenuAction}>
          <FaBars />
        </BtnBurger>

        <MenuLogo href="/za">
          <Logo />
        </MenuLogo>

        <BtnMenuLogin href="https://portal.yoco.co.za/">login</BtnMenuLogin>
      </Menu>

      <Drawer isOpen={isNavOpen}>
        <Header onClick={() => onMenuAction()}>
          <IconClose>
            <FaTimes />
          </IconClose>

          <IconLogo>
            <Logo />
          </IconLogo>
        </Header>

        <Main>
          <PortraitList>
            {links.map(link => (
              <PortraitListItem
                key={link.title}
                links={link.links}
                title={link.title}
                url={link.url}
                isOpen={link.isOpen}
                onDropDownAction={() => onDropDownAction(link.title)}
              />
            ))}
            <BtnGetStarted href={getStartedUrl}>
              Get started <FaArrowRight />
            </BtnGetStarted>
          </PortraitList>
        </Main>

        <Footer>
          {isLoginButtonVisible && (
            <PortraitLink href="https://portal.yoco.co.za/">Login</PortraitLink>
          )}
        </Footer>
      </Drawer>
    </PortraitContainer>
  )
}

NavigationPortrait.propTypes = {
  links: PropTypes.arrayOf(TypeLink),
  isNavOpen: PropTypes.bool,
  isLoginButtonVisible: PropTypes.bool,
  onDropDownAction: PropTypes.func,
  onMenuAction: PropTypes.func,
  getStartedUrl: PropTypes.string,
}

export default NavigationPortrait



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/NavigationPortrait.js